// const DEV_SERVER_URL = 'https://192.168.0.7';
const DEV_SERVER_URL = 'https://84.242.202.130:223';
// const DEV_SERVER_URL = 'https://test.medweb.org';
// const APP_PATH = '/wavelet/portal/';
const APP_PATH = '/portal/';

export const SESSION_ID = ''; //'b6c6898b-b333-37b8-0ffa-95a4a2668dd4';

export const SAVE_DRAFT = 1;
export const SAVE_FINAL = 0;

export const CONST_AUTOSAVE_LOAD = 1;
export const CONST_AUTOSAVE_DISCARD = 0;

import axios from 'axios';



export function isProductionMode() {
  return (process.env.NODE_ENV === 'production') ? true : false
}

// for outer endpoints
export function makeServerUrl(url) {
  if (isProductionMode()) {
    return url;
  } else {
    const joinChar = (url.indexOf('?') == -1) ? '?' : '&';
    const sessionId = joinChar + 'MEDWEB_SESSION_ID=' + SESSION_ID;
    return DEV_SERVER_URL + url + sessionId;
  }
}

// for this application endpoints
export function makeUrl(url) {
  if (isProductionMode()) {
    return APP_PATH + url;
  } else {
    const joinChar = (url.indexOf('?') == -1) ? '?' : '&';
    const sessionId = joinChar + 'MEDWEB_SESSION_ID=' + SESSION_ID;
    return DEV_SERVER_URL + APP_PATH + url + sessionId;
  }
}

export function makeSessionIdHeader() {
  return (isProductionMode())
    ? null
    : {'MEDWEB_SESSION_ID': SESSION_ID};
}

export function redirectUrl(url) {
  return makeUrl('service.cgi?do=redirect&to=' + escape(url)
    + '&tmp='+ (new Date().getTime()));
}

export function debug(msg) {
  if (window.tm_ui_debug == '1') {
    console.log(msg)
  }
}

export function defineObjectValue(obj, name, val) {
  if (val != undefined && val != '') {
    obj[name] = val;
  }
}

export function defineString(text) {
  if (typeof(text) == 'undefined' || text === null) return '';
  else return text;
}

export function safeEscape(text) {
  if (typeof(text) == 'undefined' || text === null) return '';
  else return escape(text);
}



export function safeSplitToArray(text, separator, count) {
  debug('safeSplitToArray');
  var resultArr = (text != undefined) ? text.split(separator) : [];
  // var resultArr = new Array(count);
  if (count) {
    for (var i=resultArr.length; i<count; i++) {
      resultArr.push('')
    }
  }
  return resultArr
}




  
export function openWindow(url) {
  if (!isProductionMode()) {
    const joinChar = (url.indexOf('?') == -1) ? '?' : '&';
    const sessionId = joinChar + 'MEDWEB_SESSION_ID=' + SESSION_ID;
    url = DEV_SERVER_URL + url + sessionId;
  }
  debug('openWindow: url=' + url);
  window.open(url, '_blank', 'resizable=yes,status=yes,scrollbars=yes');
}

  



export function makeMarkedImageId(type, layout, num)
{
  if (layout !== '') {
    return 'mi_' + type + '_' + layout + '_' + num;
  } else {
    return 'mi_' + type + '_' + num;
  }
}


export function makeLayoutImageDicomType(type, layout, num)
{
  return '' + type.toUpperCase() + '\\' + layout + '\\' + num;
}


export function makeUploadedImageUrl(consultUid, upload_id)
{
  return '/wavelet/telemedicine_lite/file_preview.cgi?suid=' + escape(consultUid)
      + '&upload_id=' + escape(upload_id)
      + '&w=160&h=120'
      + '&tmp=' + (new Date().getTime())
}



// -------------------------------------
export function escapeVerticalBar(string)
{
  if (typeof(string) == 'string') return string.replace(/\|/g, "&#124;");
  else return '';
}


export function unescapeVerticalBar(string)
{
  if (typeof(string) == 'string') return string.replace(/&#124;/g, "|");
  else return '';
}


export function splitToArrayIndexed(text, count)
{
  debug('splitToArrayIndexed');
  var resultArr = (text != undefined) ? text.split('|') : [];
  
  // populate the rest items
  for (var i=resultArr.length; i<count; i++) {
    resultArr.push('')
  }
  
  // unescape separator ??
  for (i=0; i<resultArr.length; i++) {
    resultArr[i] = unescapeVerticalBar(resultArr[i])
  }

  return resultArr
}


export function mergeFromArrayIndexed(array)
{
  debug('mergeFromArrayIndexed: ' + array.join(','));
  var result = '';
  var is_empty = true;

  for (var i=0; i<array.length; i++) {
    const v = escapeVerticalBar(array[i]);
    result += v;
    if (i < array.length-1) result += '|'; // add separator
    if (v != '') is_empty = false;
  }

  if (is_empty) {
    result = '';
  }

  debug('mergeFromArrayIndexed: result=' + result);
  return result;
}




export function mergeFromArray(array, isFixedLength)
{
  debug('mergeFromArray: ' + array.join(',') + ', isFixedLength=' + isFixedLength);
  var result = '';
  var is_empty = true;

  for (var i=0; i<array.length; i++) {
    const v = escapeVerticalBar(array[i]);
    debug('mergeFromArray: ' + i + ', value=[' + v + ']');
    if (isFixedLength) {
      debug('mergeFromArray: isFixedLength: ' + i + ', value=[' + v + ']');
      result += v;
      if (i < array.length-1) result += '|';
    } else {
      debug('mergeFromArray: NOT isFixedLength: ' + i + ', value=[' + v + ']');
      if (v != '') result += v + '|';
    }
    if (v != '') is_empty = false;
    debug('mergeFromArray: result=[' + result + ']');
  }

  if (is_empty) {
    result = '';
  }

  debug('mergeFromArray: result=' + result);
  return result;
}



export function splitToArray(text, fixedLengthCount)
{
  debug('splitToArray: text=' + text + ', fixedLengthCount=' + fixedLengthCount);
  var resultArr = (text != undefined) ? text.split('|') : [];

  debug('splitToArray: resultArr.length=' + resultArr.length
    + ', fixedLengthCount=' + fixedLengthCount);
  
  if (fixedLengthCount) {
    // populate the rest items
    for (var i=resultArr.length; i<fixedLengthCount; i++) {
      debug('splitToArray: extra: ' + i);
      resultArr.push('')
    }
  }
  
  for (i=0; i<resultArr.length; i++) {
    resultArr[i] = unescapeVerticalBar(resultArr[i])
  }

  debug('splitToArray: resultArr.length=' + resultArr.length);

  return resultArr
}




export function escapeHTML(text) 
{
  if (typeof(text) == 'undefined' || text == null) return '';
  if (typeof(text) != 'string') return text;
  text = text.replace(/&/g, '&amp;');
  text = text.replace(/"/g, '&quot;');
  text = text.replace(/</g, '&lt;');
  text = text.replace(/>/g, '&gt;');
  text = text.replace(/'/g, '&#39;');
  text = text.replace(/\\/g, '&#92;');
  return text;
}

export function unescapeHTML(text) 
{
  if (typeof(text) == 'undefined' || text == null) return '';
  if (typeof(text) != 'string') return text;
  text = text.replace(/&amp;/g, '&');
  text = text.replace(/&quot;/g, '"');
  text = text.replace(/&lt;/g, '<');
  text = text.replace(/&gt;/g, '>');
  text = text.replace(/&#39;/g, "'");
  text = text.replace(/&#92;/g, '\\');
  return text;
}




// frequently used store related functions
export function touchField(validationDefinitions, storeFieldName) {
  // debug('touchField');
  if (validationDefinitions != undefined
      &&validationDefinitions[storeFieldName] != undefined) {
    validationDefinitions[storeFieldName].$touch()
  }
}

export function updateField(store, storeFieldName, eventOrValue) {
  // debug('updateField: type of eventOrValue = ' + typeof(eventOrValue));
  // debug('updateField: eventOrValue = ' + JSON.stringify(eventOrValue));
  const newValue = (eventOrValue !== undefined && eventOrValue !== null && eventOrValue.target)
    ? eventOrValue.target.value
    : eventOrValue;
  // debug('updateField: ' + storeFieldName + ' = ' + newValue);
  const safeNewValue = '' + defineString(newValue);
  store.dispatch('form/updateField', {'name': storeFieldName,
    'value': safeNewValue.trim()});
}


export function updateFieldWithArray(store, storeFieldName, valuesArray, itemsCount) {
  const mergedValue = mergeFromArray(valuesArray, itemsCount);
  store.dispatch('form/updateField',
    {'name': storeFieldName, 'value': mergedValue});
}


// validation helpers
export function validationTouch(validationObject, fieldName) {
  // debug('validationTouch: BEFORE: fieldName=' + fieldName + ', V=' + JSON.stringify(validationObject));
  if (validationObject != undefined
      && validationObject[fieldName] != undefined) {
    debug('validationTouch: touch ' + fieldName);
    validationObject[fieldName].$touch()
  } else {
    debug('validationTouch: validationObject NOT DEFINED!!!');
  }
  // debug('validationTouch: AFTER: fieldName=' + fieldName + ', V=' + JSON.stringify(validationObject));
}


export function validationRequiredLabel(validationObject, fieldName) {
  return (validationObject != undefined
      && validationObject[fieldName] != undefined
      && validationObject[fieldName].$params.required != undefined) 
    ? 'label-required' : ''
}


export function validationFunctionFailed(validationObject, fieldName, validationFunctionName) {
  // validationFunctionName is a validation object property
  // containing the result returned by the corresponding validation function
  const result = (validationObject != undefined
      && validationObject[fieldName] != undefined
      && validationObject[fieldName].$dirty
      && validationObject[fieldName][validationFunctionName] != undefined
      && !validationObject[fieldName][validationFunctionName])
    ? true : false;
  
  debug('validationFunctionFailed: fieldName=' + fieldName + ', result=' + result);
  return result;
}

  
  



export function validateDobYearOldEnough(year) {
  if (defineString(year) == '') return true;

  const now = new Date();
  const yearNow = now.getFullYear();

  if (year < yearNow-130) {
    return false
  } else {
    return true
  }
}


export function validateDobYearYoungEnough(year) {
  if (defineString(year) == '') return true;

  const now = new Date();
  const yearNow = now.getFullYear();
  const monthNow = now.getMonth() + 1;
  const dayNow = now.getDate();

  if (year > yearNow) {
    // future year
    return false
  } 

  if (year == yearNow) {
    // this year => check day and month
    const day = defineString(this.fields['DOB_day']);
    const month = defineString(this.fields['DOB_month']);

    if (month > monthNow) {
      // return [tri18n('The date cannot be a future date, please correct.'), 'month'];
      return false
    }

    if (month == monthNow && day > dayNow) {
      // return [tri18n('The date cannot be a future date, please correct.'), 'day'];
      return false
    }
  }

  // not a future year or a future date in this year
  return true
}





export function validateDobDay(day) {
  // this.fields must be defined in the component where is used!
  const year = defineString(this.fields['DOB_year']);
  const month = defineString(this.fields['DOB_month']);
  debug('validateDobDay: after fields');
  if (month==2 && day>daysInFebruary(year)) {
    return false;
  }
  if (day > daysInMonth(month) ) {
    return false;
  }
  return true;
}


function daysInFebruary(year)
{
  // February has 29 days in any year evenly divisible by four,
  // EXCEPT for centurial years which are not also divisible by 400.
  return (((year % 4 == 0) && ( (!(year % 100 == 0)) || (year % 400 == 0))) ? 29 : 28 );
}


function daysInMonth(m)
{
  if (m==4 || m==6 || m==9 || m==11) return 30;
  if (m==2) return 29;
  return 31;
}



export function validateDuplicatePatientId() {
  // return false
  return !this.$store.getters['form/errorPatientId']
}


export function validateInsuranceNumber() {
  // $('#m_SSN').mask('9999-999-999?-aa');
  const val = defineString(this.$store.getters['form/fields'].SSN);
  if (val == '') return true;

  // debug('validateInsuranceNumber: val=' + val);
  var reOhip = /^\d{4}-\d{3}-\d{3}(-[A-Za-z]{2})?$/;
  if (val.match(reOhip)) {
    // debug('validateInsuranceNnumber: TRUE');
    return true
  } else {
    // debug('validateInsuranceNnumber: FALSE');
    return false
  }
}      




export function orderTabs(tabComponentsHash, tabOrder) {
  debug('orderTabs');

  if (tabOrder != '') {
    tabOrder = 'Demographics|' + tabOrder
  } else {
    alert("orderTabs\nFATAL: cannot get tabs order");
    return
  }

  // empty tabList array
  var tabsList = [];

  const arrTabs = tabOrder.split('|');
  for (var i=0; i<arrTabs.length; i++) {
    const tab = arrTabs[i];
    if (tabComponentsHash[tab] == undefined) {
      // no such tab definition
      continue;
    }

    const tabComponent = defineString(tabComponentsHash[tab].component);
    
    if (tab != '' && tabComponent != '') {
      var tabItem = { title: tab,
        name: tabComponentsHash[tab].name,
        component: tabComponent,
        isValid: tabComponentsHash[tab].isValid
      };
      if (tabComponent == 'CustomTab') {
        tabItem.index = tabComponentsHash[tab].index;
      }
      tabsList.push(tabItem);
    }
  }

  // manage tab navigation buttons
  var tabCount = tabsList.length;
  for (i=0; i<tabCount; i++) {
    const firstTab = (i==0) ? true : false;
    const lastTab = (i==tabCount-1) ? true : false;
    tabsList[i].showPrevButton = !firstTab;
    tabsList[i].showNextButton = !lastTab;
    tabsList[i].showSaveButton = lastTab;
  }

  debug('orderTabs: complete.');

  return tabsList
}


export function formatDateToPg(dateUtc) {
  if (dateUtc == undefined) return undefined;
  const dateLocal = new Date(dateUtc);
  const y = dateLocal.getFullYear();
  var m = dateLocal.getMonth() + 1;
  if (m < 10) m = '0' + m;
  var d = dateLocal.getDate();
  if (d < 10) d = '0' + d;
  return '' + y + m + d
}


export function isEmptyObject(object) {
  for(var i in object) {
    return false;
  }
  return true;
} 


// view consult functions
// export function viewCase(vm, case_uid, viewer_type, same_wnd)
export function viewConsultImages(vm, case_uid, same_wnd)
{
  // IMPORTANT:
  // a hidden iframe with src==data.hiddenFrameSrc 
  // must de defined in the calling component

  debug('viewConsultImages: uid=' + case_uid);

  const viewer_type = defineString(vm.$store.getters['config/userProps'].viewerType);
  debug('viewConsultImages: viewer_type=' + viewer_type);


  if(navigator.appVersion.indexOf('Win') == -1) {
    select_case_web(case_uid, same_wnd); // not Windows => run web viewer
    return;
  }

  var url;
  switch (viewer_type) {
    case '1': // zero footprint viewer
      url = makeServerUrl('/wavelet/study_list.2.0.cgi?opcode=quick_view&study=' + escape(case_uid));
      break;
    case '2': // Advanced Viewer (Browser Neutral)
      runViewerHandler(vm, case_uid);
      return;
    case '3': // web viewer
      select_case_web(case_uid, same_wnd);
      return;
    default:
      url = makeServerUrl('/wavelet/study_list.2.0.cgi?opcode=plugin_stream&recode=frames&only_keyimages=0&comp_amt=1&study=' + escape(case_uid));
  }

  debug('viewConsultImages: url: ' + url);
  openWindow(url)
}


// export 
function select_case_web(case_uid, same_wnd)
{
  debug('select_case_web: uid=' + case_uid + ', same_wnd=' + same_wnd);

  const url = makeServerUrl('/wavelet/webviewer/index.html?study=' + escape(case_uid) +
    '&TELEMED_MODE=1&now=' + (new Date().getTime()));

    debug('select_case_web: url=' + url);

  openWindow(url)
}



function runViewerHandler(vm, study_uid)
{
  debug('runViewerHandler')

  var url = makeServerUrl('/wavelet/study_list.2.0.cgi?opcode=plugin_other_params&study=' + escape(study_uid));
  debug('runViewerHandler: url.1: '+url);

  axios.get(url)
    .then(response => {
      debug('runViewerHandler: response: '+JSON.stringify(response));

      if(response.data && response.data.length) {
        var protocol = location.protocol;
        var secure = (protocol == 'https:') ? 's' : '';
        var url = 'medweb-viewer' + secure + '://' + location.hostname;
        if (location.port != '') url += ':' + location.port;

        url += '/wavelet/study_list.2.0.cgi?study=' + escape(study_uid)
          + '&use_machine=' + escape(location.hostname)
          + '&query_target='
          + '&opcode=frames'
          + '&only_keyimages=0'
          + '&only_annotated=0'
          + '&now=' + (new Date()).getTime()
          + '&.' + response.data;

        debug('runViewerHandler: url.2: '+url);
        if (vm.hiddenFrameSrc !== undefined) {
          vm.hiddenFrameSrc = url
        } else {
          debug('runViewerHandler: ERROR: hiddenFrameSrc is not defined in the calling component');
        }
        
      }
    }, error => {
      debug('runViewerHandler: error: ' + error);
      const msg = parseNetworkError(error);
      alert('Error: cannot get Medweb Viewer parameters.\n' + msg);
    }
  )
}


export function parseNetworkError(error)
{
  debug('parseNetworkError');

  if (typeof error === 'string' || error instanceof String) {
    return { status: 200, text: error }
  }

  var result = {};
  
  if (error.response != undefined) {
    result.status = error.response.status
  } else {
    result.status = 0;
  }

  switch (result.status) {
    case 402: 
      result.text = 'The server license is expired.';
      break;
    case 403: 
      result.text = 'Not logged in.';
      break;
    case 500: 
      result.text = 'Server error.';
      break;
    default:
      result.text = error.message;
  }
  
  return result;
}


export function isMSIE() {
  var ua = window.navigator.userAgent;
  return (ua.indexOf("MSIE ") > 0 || !!ua.match(/Trident.*rv:11\./))
}



export function isNumber(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}


export function isIntNumber(n) {
  return !isNaN(parseInt(n)) && isFinite(n);
}




export function convertPipeSeparatedStringToObject(pipe_separated_str)
{
  // convert |-separated string to object
  debug('convertPipeSeparatedStringToObject')
  var result = {};
  pipe_separated_str = defineString(pipe_separated_str);
  var array = pipe_separated_str.split('|');
  for (var i=0; i<array.length; i++) {
    debug('convertPipeSeparatedStringToObject: val=' + array[i]);
    if (defineString(array[i]) != '')
      result[array[i]] = 1;
  }
  return result;
}


export function convertObjectToPipeSeparatedString(argObject)
{
  // convert object to |-separated string
  debug('convertObjectToPipeSeparatedString: ' + JSON.stringify(argObject));
  debug('convertObjectToPipeSeparatedString: typeof=' + typeof(argObject));
  // var array = $.map(object, function(value, index) { return [index]; });
  var array = Object.keys(argObject);
  // var pipe_separated_string = array.join('|');
  var pipe_separated_string = array.join('|');
  if (pipe_separated_string == '|') pipe_separated_string = '';
  return pipe_separated_string;
}


export function bytesToSize(bytes) {
  var sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
  if (bytes == 0) return '0';
  var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
  if (i == 0) return bytes + ' ' + sizes[i];
  return (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
}


export function getDefaultCaseView(userProps, optionsCaseView) {
  var defaultCaseView = defineString(userProps.tm_default_case_view);
  if (defaultCaseView == ''
      || optionsCaseView.find(item => item.value == defaultCaseView).length == 0) {
    // default case view is not set or not allowed => determine based on user type
  
    if (userProps.isRegulator == '1') {
      debug('getDefaultCaseView: isRegulator');
      defaultCaseView = 'ongoing';
    } else {
      if (userProps.isResident == '1') {
        debug('getDefaultCaseView: isResident');
        defaultCaseView = 'review';
      } else {
        if (userProps.isConsulting == '1') {
          debug('getDefaultCaseView: isConsulting');
          defaultCaseView = 'assigned';
        } else {
          defaultCaseView = 'new';
        }
      }
    }
  }

  debug('getDefaultCaseView: result=' + defaultCaseView);
  return defaultCaseView;
}



export function getPatientPhotoUrl(studyUid, photoUid, size, timestamp) {
  return (photoUid != undefined && photoUid != '')
    ? makeUrl('service.cgi?get=object_thumbnail'
      + '&suid=' + safeEscape(studyUid)
      + '&attached_uid=' + safeEscape(photoUid)
      + '&upload_id=' // 'photo' ???
      + '&size=' + size
      + '&type=report'
      + '&tmp=' + timestamp) //(new Date().getTime()))
    : ''
}


export function makeCombinedValue(arrValue, strValue) {
  var result = '';
  if (Array.isArray(arrValue)) {
    result = arrValue.join('; ');
  } else {
    result = defineString(arrValue);
  }

  strValue = defineString(strValue);
  if (result != '') {
    if (strValue != '') {
      result += '; ' + strValue;
    }
  } else {
    result = strValue;
  }
  return result;
}



export function isElementInViewport (el) {
  var rect = el.getBoundingClientRect();
  debug('isElementInViewport: top=' + rect.top + ', bottom=' + rect.bottom);
  return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
      rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
  );
}
